import { render } from "./AccessProvider.vue?vue&type=template&id=6ee3dd1b"
import script from "./AccessProvider.vue?vue&type=script&lang=js"
export * from "./AccessProvider.vue?vue&type=script&lang=js"

import "./AccessProvider.vue?vue&type=style&index=0&id=6ee3dd1b&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__